/**
 * to display the marketplace seller info on PDP
 *
 * @module views/components/SellerInfo
 * @memberof -Common
 */
import './SellerInfo.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Text as PalText } from 'web-palette/dist/components/Text/Text';

import Button from '@ulta/core/components/Button/Button';
import Icon from '@ulta/core/components/Icon/Icon';

import Divider from '../Divider/Divider';


/**
 * Represents a SellerInfo component
 *
 * @method
 * @param { SellerInfoProps} props - React properties passed from composition
 * @returns SellerInfo
 */
export const SellerInfo = function( props ){

  const { action, icon, message, brandName, sellerId, showDivider = false, className } = props;

  const updatedAction = {
    ...action,
    variables: {
      moduleParams: { brandName, sellerId }
    }
  };

  return (
    <div className={ classNames( `SellerInfo`, className ) }>
      { showDivider && <Divider /> }
      <div className='SellerInfo__Content'>
        { icon && <Icon name={ icon } size='s' aria-hidden={ true }/> }
        { message && <PalText textStyle='body-sm'>{ message }</PalText> }
        { action && <Button action={ updatedAction } label={ action?.label } likeLink size={ 'compact' } screenReaderText={ action?.accessibility?.label }/> }
      </div>
      { showDivider && <Divider /> }
    </div>

  );
};

/**
 * Property type definitions
 * @typedef SellerInfoProps
 * @property {string} action=action to the seller name link
 * @property {string} icon=icon to the seller info
 * @property {string} message=message to the seller info
 * @property {string} brandName=brandName to the seller info
 * @property {string} sellerId=sellerId to the seller info
 */
export const propTypes =  {
  action:PropTypes.object,
  icon:PropTypes.string,
  message:PropTypes.string,
  brandName:PropTypes.string,
  sellerId:PropTypes.string
};

/**
 * Default values for passed properties
 *
 * @property {string} action=action to the seller name link
 * @property {string} icon=icon to the seller info
 * @property {string} message=message to the seller info
 * @property {string} brandName=brandName to the seller info
 * @property {string} sellerId=sellerId to the seller info
 */
export const defaultProps =  {
  action:null,
  icon:'',
  message:'',
  brandName:'',
  sellerId:''
};

SellerInfo.propTypes = propTypes;
SellerInfo.defaultProps = defaultProps;

export default SellerInfo;
